export default __webpack_public_path__ + "static/media/nav_user_img.d2fe31b8.svg";